import dayjs, { Dayjs } from 'dayjs';
import { LabeledValue, SelectValue } from 'antd/lib/select';
import { useAppSelector } from 'hooks/store-hooks';
import { FilterReturnType } from 'hooks/use-filter';
import wimSelectors from 'store/wim/selectors';
import { TransitsFilterValues } from 'store/wim/types/transits';
import { OPTION_KEYS_FOR_SELECT } from 'app-constants/select-options';
import { useGetMonitoringMetrics } from 'pages/Wim/Monitoring/WimMonitoringFilter/hooks/use-get-monitoring-metrics';

export function useWimOperationalQualityFilter<TransitsType extends TransitsFilterValues>({
  state,
  handleFilterChange,
}: Pick<FilterReturnType<Partial<TransitsType>>, 'handleFilterChange' | 'state'>) {
  const platforms = useAppSelector(wimSelectors.platforms.getPlatforms);
  useGetMonitoringMetrics();
  const metrics = useAppSelector(wimSelectors.monitoring.getWimMonitoringMetrics) ?? [];
  const onPlatformNameChange = (value: SelectValue) => {
    handleFilterChange('wimIds', value);
  };

  const onRangePickerChange = (ranges: [Dayjs | null, Dayjs | null] | null) => {
    if (!ranges) {
      return;
    }
    const [start, end] = ranges;

    if (start && end) {
      handleFilterChange('start', dayjs(start).valueOf());
      handleFilterChange('end', dayjs(end).valueOf());
    }
  };

  const onTransitErrorChange = (value: SelectValue) => {
    if (value && Array.isArray(value)) {
      if (value.includes(OPTION_KEYS_FOR_SELECT.All as string & LabeledValue)) {
        handleFilterChange(
          'measurementFlags',
          metrics.map((metric) => metric?.filters?.measurementFlags?.[0])
        );
      } else {
        handleFilterChange('measurementFlags', value);
      }
    }
  };

  const onMultiDatePickerChange = (notWorkedDates: Dayjs[]) => {
    handleFilterChange(
      'notWorkedDates',
      notWorkedDates.map((date: Dayjs) => date.startOf('day').valueOf())
    );
  };

  return {
    state,
    platforms,
    handleFilterChange,
    onPlatformNameChange,
    onRangePickerChange,
    onMultiDatePickerChange,
    onTransitErrorChange,
    metrics,
  };
}
